// ─────────────────────────────────────────────────────────────────────────────
// useForgotPassword — owns the forgot-password form state and the submit call, so
// the page stays presentational (mirrors useLoginForm / useAcceptInvite).
// Calls POST /auth/forgot-password. The backend always responds 200 with the same
// message whether or not the account exists (no enumeration), so `sent` just
// flips to show the neutral confirmation.
// ─────────────────────────────────────────────────────────────────────────────
import { useState } from "react";
import authService from "../../../services/authService";
import { validateEmail } from "../utils/validators";

export function useForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    const emailErr = validateEmail(email);
    if (emailErr) { setError(emailErr); return; }
    setError("");
    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return { email, setEmail, loading, error, sent, submit };
}

export default useForgotPassword;
